import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Stack, CircularProgress, Typography } from "@mui/material";
const InlineLoading = ({ label, minHeight = 240 }) => {
  const { t } = useTranslation("ui");
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      spacing: 1.5,
      alignItems: "center",
      justifyContent: "center",
      sx: {
        flex: 1,
        height: "100%",
        minHeight,
        p: 3,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ jsx(CircularProgress, { size: 28, color: "inherit" }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", sx: { color: "text.secondary" }, children: label ?? t("데이터를 불러오고 있습니다.") })
      ]
    }
  );
};
export {
  InlineLoading
};
